import { render, staticRenderFns } from "./UKMapSection.vue?vue&type=template&id=25175933&"
import script from "./UKMapSection.vue?vue&type=script&lang=js&"
export * from "./UKMapSection.vue?vue&type=script&lang=js&"
import style0 from "./UKMapSection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports